module.exports = ".image-wrapper {\n    -webkit-box-shadow: 0 2px 5px 0 rgba(0,0,0,.15);\n            box-shadow: 0 2px 5px 0 rgba(0,0,0,.15);\n    height: 300px !important;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n}\n\n.block-image-upload img {\n    padding: 0px !important;\n}\n\n.row-margin {\n    margin-bottom: 15px !important;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/add-contract/add-contract.component.css
// module id = ./src/app/add-contract/add-contract.component.css
// module chunks = main